import { AnimatePresence } from "framer-motion";
import { useUI } from "@context/UIContext";
import Toast from "./Toast";

/**
 * ToastContainer — mounted once near the root of the app shell (Phase 4's
 * root layout). Renders every active toast from UIContext, stacked above
 * the bottom navigation.
 */
export default function ToastContainer() {
  const { toasts, dismissToast } = useUI();

  return (
    <div className="fixed left-1/2 -translate-x-1/2 bottom-24 z-toast flex flex-col items-center gap-2 px-4 w-full max-w-app pointer-events-none">
      <AnimatePresence mode="popLayout">
        {toasts.map((toast) => (
          <div key={toast.id} className="pointer-events-auto w-full flex justify-center">
            <Toast
              message={toast.message}
              type={toast.type}
              onDismiss={() => dismissToast(toast.id)}
            />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
}
